import { LeaderboardTrialInvitesInfoModule } from './../leaderboard-trial-invites-info/leaderboard-trial-invites-info.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LoaderModule } from '@app/shared';
import { PipeModule } from '@app/shared';
import { FormsModule } from '@app/shared/forms';

import { LeaderboardPreviewGoalComponent } from './leaderboard-preview-goal.component';
import { AriaHiddenModule } from '@app/shared/accesibility/aria-hidden/aria-hidden.module';
import { DataTestModule } from '@app/shared/directive/data-test';
import { IconComponent } from '@app/tw-shared/components';
import { ReactiveFormsModule } from '@angular/forms';
import { FormDropdownModule } from '@app/tw-shared/forms/form-dropdown/form-dropdown.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbTooltipModule,
        TranslateModule,
        InlineSVGModule,
        LoaderModule,
        LeaderboardTrialInvitesInfoModule,
        PipeModule,
        FormsModule,
        AriaHiddenModule,
        DataTestModule,
        IconComponent,
        ReactiveFormsModule,
        FormDropdownModule,
    ],
    declarations: [LeaderboardPreviewGoalComponent],
    exports: [LeaderboardPreviewGoalComponent],
})
export class LeaderboardPreviewGoalModule {}
